import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { UiBsTranslateService, UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

let UiCPaginatorComponent = class UiCPaginatorComponent {
    constructor(translate) {
        this.translate = translate;
        // EventEmitter
        this.handleGoToFirstPage = new EventEmitter();
        this.handleGoToLastPage = new EventEmitter();
        this.handleGoToNextPage = new EventEmitter();
        this.handleGoToPrevPage = new EventEmitter();
        this.handleChangeItemsPerPage = new EventEmitter();
    }
    ngOnInit() {
    }
    handleClickGoToFirst() {
        this.handleGoToFirstPage.emit();
    }
    handleClickGoToPrev() {
        this.handleGoToPrevPage.emit();
    }
    handleClickGoToNext() {
        this.handleGoToNextPage.emit();
    }
    handleClickGoToLast() {
        this.handleGoToLastPage.emit();
    }
    changeItemsPerPage(itemsPerPage) {
        this.handleChangeItemsPerPage.emit(itemsPerPage);
    }
    hasNext() {
        return this.totalPages <= this.currentPage;
    }
    hasLast() {
        return this.currentPage <= 1;
    }
};
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCPaginatorComponent.prototype, "itemsPerPage", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCPaginatorComponent.prototype, "itemsPerPageOptions", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCPaginatorComponent.prototype, "itemsDisplayed", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCPaginatorComponent.prototype, "totalElements", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCPaginatorComponent.prototype, "currentPage", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCPaginatorComponent.prototype, "totalPages", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPaginatorComponent.prototype, "i18nTextLegend", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPaginatorComponent.prototype, "i18nTextBtnOk", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPaginatorComponent.prototype, "i18nTextBtnCancel", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPaginatorComponent.prototype, "i18nTextResume", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPaginatorComponent.prototype, "i18nTextIndex", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPaginatorComponent.prototype, "i18nTextShow", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPaginatorComponent.prototype, "iconSkipLast", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPaginatorComponent.prototype, "iconNavigateLast", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPaginatorComponent.prototype, "iconNavigateNext", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPaginatorComponent.prototype, "iconSkipNext", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCPaginatorComponent.prototype, "handleGoToFirstPage", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCPaginatorComponent.prototype, "handleGoToLastPage", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCPaginatorComponent.prototype, "handleGoToNextPage", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCPaginatorComponent.prototype, "handleGoToPrevPage", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCPaginatorComponent.prototype, "handleChangeItemsPerPage", void 0);
UiCPaginatorComponent = __decorate([
    Component({
        selector: 'ui-c-paginator',
        template: "<div class=\"pagination\">\n  <div class=\"center\">\n\n    <div>\n      <p> {{i18nTextShow | wlpTranslate}} </p>\n      <ion-item class=\"select-items-per-page\">\n        <ion-select\n          [interfaceOptions]=\"{ header: i18nTextLegend | wlpTranslate}\"\n          [okText]=\"i18nTextBtnOk | wlpTranslate\"\n          [cancelText]=\"i18nTextBtnCancel | wlpTranslate\"\n          [placeholder]=\"itemsPerPage\"\n          (ionChange)=\"changeItemsPerPage($event.detail.value)\">\n          <ion-select-option *ngFor=\"let item of itemsPerPageOptions\" [value]='item'>\n            {{item}}\n          </ion-select-option>\n        </ion-select>\n      </ion-item>\n      <p> {{i18nTextResume | wlpTranslate: { itemsDisplayed: itemsDisplayed, totalElements: totalElements } }} </p>\n    </div>\n\n    <div>\n      <ion-button fill=\"clear\" (click)=\"handleClickGoToFirst()\" [disabled]=\"hasLast()\" >\n        <ion-icon  class=\"ionicon\" [src]=\"iconSkipLast\"  ></ion-icon>\n      </ion-button>\n      <ion-button fill=\"clear\" (click)=\"handleClickGoToPrev()\" [disabled]=\"hasLast()\" >\n        <ion-icon  class=\"ionicon\" [src]=\"iconNavigateLast\"></ion-icon>\n      </ion-button>\n\n      <p> {{ i18nTextIndex | wlpTranslate: { currentPage: currentPage, totalPages: totalPages } }} </p>\n\n      <ion-button fill=\"clear\" (click)=\"handleClickGoToNext()\" [disabled]=\"hasNext()\" >\n      <ion-icon class=\"ionicon\" [src]=\"iconNavigateNext\"></ion-icon>\n      </ion-button>\n      <ion-button fill=\"clear\" (click)=\"handleClickGoToLast()\" [disabled]=\"hasNext()\" >\n        <ion-icon class=\"ionicon\" [src]=\"iconSkipNext\"></ion-icon>\n      </ion-button>\n    </div>\n\n  </div>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [UiBsTranslateService])
], UiCPaginatorComponent);

var UiCPaginatorModule_1;
let UiCPaginatorModule = UiCPaginatorModule_1 = class UiCPaginatorModule {
    static forRoot(config) {
        return {
            ngModule: UiCPaginatorModule_1,
            providers: [{ provide: APP_PARAMETER, useValue: config }],
        };
    }
};
UiCPaginatorModule = UiCPaginatorModule_1 = __decorate([
    NgModule({
        declarations: [UiCPaginatorComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule,
            UiBsTranslateModule
        ],
        exports: [UiCPaginatorComponent]
    })
], UiCPaginatorModule);

export { UiCPaginatorComponent, UiCPaginatorModule };
//# sourceMappingURL=wlp-ui-c-paginator.js.map
